import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { CreatePriceCategoryDTO, EventsApiService } from 'features/events';
import { queryClient } from 'providers';

import { eventsQueryKeys } from './query-keys';

const { createPriceCategory } = EventsApiService();

export const useCreatePriceCategory = (id: any) => {
    const { message } = App.useApp();

    return useMutation(
        (payload: CreatePriceCategoryDTO) => {
            return createPriceCategory(payload);
        },
        {
            onError: (error) => {
                const uiMessage = handleError(error);

                message.error(uiMessage);
            },
            onSuccess: () => {
                queryClient.invalidateQueries({
                    queryKey: eventsQueryKeys.all,
                });
                if (id) {
                    message.success("Ticket has been updated successfully!!");
                } else {
                    message.success("Ticket has been created successfully!!");
                }
            },
        },
    );
};
